import { createFeatureSelector } from '@ngrx/store';

import type { BecomeACustomerState } from './become-a-customer-state.interface';

export const becomeACustomerSelectorKey = 'become-a-customer';

export const getBecomeACustomerState =
  createFeatureSelector<BecomeACustomerState>(becomeACustomerSelectorKey);
